import React, { memo, useCallback } from "react";

const TextArea = memo(({ value, setValue }) => {
  const handleChange = useCallback((e) => setValue(e.target.value), [setValue]);

  return ( 
	<textarea 
		className="letter__txt"
		onChange={(e) => handleChange(e)}
        value={value}
	></textarea>
  );
});

export default TextArea;
